import http, {configForm, configJson} from "@/api/config/http-configs";


/**
 * system setting enum target:
 * MOBILE  设置应用在移动端
 * TERMINATE   设置应用在访客机端
 * MANAGE  设置应用在管理前端
 * ALL 所有的端都可以使用
 */

/**
 * system setting enum param
 * SYSTEM_NAME,     // 系统名称
 * COMPANY_LOGO,    // 公司logo
 * HOME_WELCOME,    // 首页欢迎语
 * USER_AGREEMENT,  // 用户协议
 * VISITOR_NOTICE,  // 访客须知
 * SECRET_AGREEMENT // 隐私协议
 */
export const getMobileSettingInfo = () => {
    //"targetList":["MOBILE", "TERMINATE"],
    // "typeList":["SYSTEM_NAME", "COMPANY_LOGO", "HOME_WELCOME"]
    const targetList = ["MOBILE"]
    const typeList = ["SYSTEM_NAME", "COMPANY_LOGO", "HOME_WELCOME"]

    return http.post(`/mobile/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

export const getTerminateSettingInfo = () => {
    const targetList = ["TERMINATE"]
    const typeList = ["SYSTEM_NAME", "COMPANY_LOGO", "HOME_WELCOME", "HOME_BACKGROUND", "HOME_QR_REGISTER", "HOME_ENTER_SETTING", "HOME_BANNER_LIST"]
    // gf 的 []string 不拆逗号串：querystring 单键逗号分隔绑定为空导致恒查不到数据，须走 JSON body
    return http.post(`/mobile/setting/list`, {targetList, typeList}, configJson)
}


export const getEntranceSetting = () => {
    const targetList = ["DOORGUARD"]
    const typeList = ["USUAL_RULE", "GENERAL_RULE"]
    return http.post(`/mobile/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}
export const getVisitorConfigSetting = () => {
    const targetList = ["VISITORINFO"]
    const typeList = ["CER_TYPE"]
    return http.post(`/mobile/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}


// todo fix when 员工助手需求来时修改，通过 mixin_visitor_setting 中 setupWithMobile 统一调用处理
export const getInviteVisitorFormSettingWithMobile = () => {
    const targetList = ["VISITORINFO"]
    const typeList = ["VISITOR_INVITE"]
    return http.post(`/mobile/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

export const getVisitorAgreementFromSetting = () => {
    const targetList = ["ALL"]
    const typeList = ["VISITOR_NOTICE"]
    return http.post(`/mobile/setting/list?targetList=${targetList}&typeList=${typeList}`, null, configForm)
}

